import { EnvironmentBannerLayout } from "@homebound/beam";
import { Outlet } from "react-router-dom";
import { ErrorBoundary } from "src/components/ErrorBoundary";
import { getBackendStage } from "src/context";
import { useCurrentUser } from "src/hooks/useCurrentUser";

/**
 * Bare `EnvironmentBannerLayout` shell for `StepperLayout`-based pages, which per Beam's contract
 * must nest directly under `EnvironmentBannerLayout` and never under `NavbarLayout`/`GlobalNavLayout`.
 *
 * Role: data router pathless layout route.
 */
export function FocusedLayout() {
  const { name, user } = useCurrentUser();
  const stage = getBackendStage();
  const isImpersonating = user?.isBeingImpersonated ?? false;

  return (
    <EnvironmentBannerLayout environmentBanner={{ env: stage, impersonating: isImpersonating ? { name } : undefined }}>
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </EnvironmentBannerLayout>
  );
}
